export const API = {
  uploadFile: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/UploadFile`,
  uploadMyDocument: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/upload-mydocument`,
  downloadMyDocument: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/download-mydocument?documentId=`,
  downloadFile: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadFileByDocId?documentId=`,
  downloadFileByName: `${window.REACT_APP_API_GATEWAY_URL}/portal/api/Asset/DownloadFileByFileName?fileName=`,
  uploadPhoto: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/UploadFile`,
  saveLogWhenUserLoginErrors: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/personal-data/Producer/SaveLogWhenUserLoginErrors`,
};
